import { FormikHelpers } from "formik";
import { useGetCostBy } from "./api/getCostBy";
import CostByForm from "./CostByForm";
import { useEditCostBy } from "./api/editCostBy";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditCostBy = ({handleCloseModal, costById}: EditCostByProps)  => {
  const getCostByQuery = useGetCostBy({costById: costById})
  const editCostByMutation = useEditCostBy({data: {}, costById});

  const handleSubmit = async (values: IPostEditCostBy, { setSubmitting }: FormikHelpers<IPostEditCostBy>): Promise<void> => {
    try {
      await editCostByMutation.mutateAsync({
        data: values,
        costById: costById
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getCostByQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getCostByQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της παράμετρου 'Κόστος ανά'</div>
    )
  }

  return (
    <>
      {!getCostByQuery.isLoading && getCostByQuery.data &&
        <CostByForm initialValues={getCostByQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditCostByProps {
  costById: number;
  handleCloseModal: () => void;
}

export default EditCostBy;